import React, {useContext} from "react";
import { ContainerCrear } from "components/ContainerCrear";
import { TipoAbsentismoEditar } from "./tipoAbsentismo-editar";
import DrawerCamposPersonalizados from "./tipoAbsentismo-editar/DrawerCamposPersonalizados";
import DrawerArchivoAdjunto from "./tipoAbsentismo-editar/DrawerArchivoAdjunto";
import { SecurityContext } from "context/SecurityContextProvider";

const EditarTipoAbsentismoPage = () => {
  const { getUsuarioAutenticado } = useContext(SecurityContext);
  const isSDF = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20330791684" ? true : false;
  const isSDFEnergia = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20512436090" ? true : false;

  return (
    <ContainerCrear
      titulo={(isSDF || isSDFEnergia) ? "Editar Tipo Movimiento" : "Editar Tipo Absentismo"}
      descripcion={(isSDF || isSDFEnergia)? "Formulario para editar los tipos de movimientos para tu organización":"Formulario para editar los tipos de absentismos para tu organización"}
      colSpan={12}
    >
      <TipoAbsentismoEditar />
      <DrawerCamposPersonalizados/>
      <DrawerArchivoAdjunto/>
    </ContainerCrear>
  );
};
export default EditarTipoAbsentismoPage;
